export const state = () =>({
    selected_columns: [ //已選的列表表頭
        { text: "投保人姓名", value: "holder_name" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "客戶等級", value: "level" , width: "10", horizontal: "center", virtical: "top", selected: true},         
        { text: "保單登記地址", value: "insurance_address" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "電話", value: "phone" , width: "15", horizontal: "left", virtical: "top", selected: true},
        { text: "聯絡地址", value: "connection_address" , width: "20", horizontal: "left", virtical: "top", selected: true},
    ],
    total_columns: [ //可選的列表表頭
        { text: "投保人姓名", value: "holder_name" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "性別", value: "sex" , width: "5", horizontal: "center", virtical: "top", selected: false},         
        { text: "出生日期", value: "birthday" , width: "10", horizontal: "center", virtical: "top", selected: false},         
        { text: "客戶等級", value: "level" , width: "10", horizontal: "center", virtical: "top", selected: true},         
        { text: "保單登記地址", value: "insurance_address" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "電話", value: "phone" , width: "15", horizontal: "left", virtical: "top", selected: true},
        { text: "Email", value: "email" , width: "15", horizontal: "left", virtical: "top", selected: false},
        { text: "聯絡地址", value: "connection_address" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "英文姓名", value: "eng_name" , width: "15", horizontal: "left", virtical: "top", selected: false},
        { text: "業務員姓名", value: "salesman_name" , width: "15", horizontal: "left", virtical: "top", selected: false},
    ],
})

export const getters = {
    getSelectHolderExportColumns(state){
        var columns = state.selected_columns
        if (columns == null) columns = []
        return state.selected_columns
    },
    getAllHolderExportColumns: state => state.total_columns
}

export const mutations = {
    setSelectedHolderExportColumns(state, payload){
        state.selected_columns = payload
    }
}